import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import Content from '../Content';


function Announcements() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch('http://localhost:3003/TESTAnnouncements'); // fetch all announcements
        if (!response.ok) {
          throw new Error('Failed to fetch announcements');
        }
        const data = await response.json();
        setAnnouncements(data);
        setIsLoaded(true);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError(err.message);
      }
    };

    fetchAnnouncements();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!isLoaded) {
    return <div 
              style={{ 
                height:"100vh",
                marginTop: "30%",
                marginRight: "25%",
                marginLeft: "25%" 
                }}>
                  <Card className="card-body"
                   style={{ 
                textAlign: "center", 
                }}
                  >
                    <h1>Loading...</h1>
                  </Card>
              </div>
              ;
  }

  return (
    <div style={{ marginTop: '10%', }}>
      <Card className='align-items-center '>
        <h1
          style={{
            // marginTop: '50px',
             WebkitTextStroke: '2px rgb(243, 174, 61)', // <-- outline around letters
            color: 'black', 
          }}
        >
          Announcements
        </h1>
      </Card>

      <div> 
      <div >
        <div className='container-fluid'>  
        <div className="row align-items-center">
              <Content announcements={announcements} title="Announcements" />
        </div>
      </div>
      </div>
      <br></br>
      <div> 
      </div> 
      </div>
    </div>
  );
}

export default Announcements;
